import { useAppSelector } from "@store";
import { getDesignSystem } from "@store/story/selectors";
import debounce from "lodash.debounce";
import { useCallback, useEffect, useRef, useState } from "react";

export const useDesignSystemChange = () => {
  "use no memo";
  const [trigger, setTrigger] = useState(0);
  const designSystem = useAppSelector(getDesignSystem);
  const debouncedRef = useRef<ReturnType<typeof debounce>>();

  // Create debounced callback only once and store in ref
  debouncedRef.current = useCallback(
    debounce(() => {
      setTrigger((prev) => prev + 1);
    }, 100),
    [],
  );

  useEffect(() => {
    debouncedRef.current?.();
  }, [designSystem]);

  // Return both trigger value and a key for forcing re-renders
  return `design-system-${trigger}`;
};
